
export default function compareTime(validity_end_date: string, validity_start_date: string){
    var now = new Date();
    var end = new Date(validity_end_date)
    var start = new Date(validity_start_date)
    if (now.getTime() > end.getTime())
        return "past"
    else if (now.getTime() < start.getTime())
        return "notYet"
    else if(now.getTime() < end.getTime() && now.getTime() > start.getTime())
        return "valid"
    else
        return ""
}

